import { render, staticRenderFns } from "./NewslettersSignupStepLayout.vue?vue&type=template&id=c5217e28"
import script from "./NewslettersSignupStepLayout.vue?vue&type=script&lang=ts"
export * from "./NewslettersSignupStepLayout.vue?vue&type=script&lang=ts"
import style0 from "./NewslettersSignupStepLayout.vue?vue&type=style&index=0&id=c5217e28&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@4.3.0_lodash@4.17.21_prettier@2.8.8_react-dom@18.3.1_react@17.0_5ioacul63gvtxmolb2qhpey7py/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports